import { render, staticRenderFns } from "./ManualUpload.vue?vue&type=template&id=bd143c4a"
import script from "./ManualUpload.vue?vue&type=script&lang=js"
export * from "./ManualUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports